import "core-js/modules/es.number.constructor";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Bus from '@/util/eventBus';
import MagicService from '@/service/magic';
import CommonTitle from '../common/CommonTitle/CommonTitle.vue';
import TickList from '../TickList/TickList.vue';
export default {
  props: {
    num: {
      type: Number,
      default: 1
    }
  },
  components: {
    CommonTitle: CommonTitle,
    TickList: TickList
  },
  computed: {
    hasBook: function hasBook() {
      return this.$store.state.hasBook;
    },
    settingConfig: function settingConfig() {
      return window.setting.告别时刻;
    },
    noStart: function noStart() {
      var startTime = window.setting.直播开始时间;
      var now = this.$store.state.now;
      return now < startTime;
    },
    descConfig: function descConfig() {
      var config = this.settingConfig.开通会员[this.isLiveEnd ? '点播期' : '直播期'];
      config = config[this.vipService.isVip ? 'vip' : '非vip'];
      return config;
    }
  },
  methods: {
    buyTicket: function buyTicket() {
      var _this = this;

      if (!this.loginService.isLogin) {
        this.$openLogin();
        return;
      }

      if (!this.vipService.isVip) {
        var reportData = this.reportData.开通弹框;
        this.exposeOpenPop();
        this.confirm({
          msg: window.setting.开通弹框文案,
          cancelText: '以原价购买',
          confirmText: '立即前往',
          cancel: function cancel() {
            _this.$report.click(reportData.原价购买);

            Bus.$emit('showBuyPanel');
          },
          confirm: function confirm() {
            _this.$report.click(reportData.开通会员);

            _this.openVip();
          }
        });
        return;
      }

      Bus.$emit('showBuyPanel');
    },
    exposeOpenPop: function exposeOpenPop() {
      var reportData = this.reportData.开通弹框;
      this.$report.expose(reportData.mod);
      this.$report.expose(reportData.原价购买);
      this.$report.expose(reportData.开通会员);
    },
    refreshBookState: function refreshBookState() {
      return this.$store.dispatch('hasBookAct');
    },
    bookAct: function bookAct() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.loginService.isLogin) {
                  _context.next = 3;
                  break;
                }

                _this2.$openLogin();

                return _context.abrupt("return");

              case 3:
                if (!_this2.hasBook) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                _context.prev = 5;
                _context.next = 8;
                return MagicService.bookAct();

              case 8:
                _this2.refreshBookState();

                _this2.toast('已预约，关注【腾讯视频VIP】公众号，开播前提醒你哟');

                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](5);
                console.error(_context.t0);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 12]]);
      }))();
    },
    launchShare: function launchShare() {
      Bus.$emit('launchShare', {
        type: 0,
        num: this.selfTicketCount || 1,
        sendDesc: this.selfTicketCount ? '已支持' : '已获得'
      });
    }
  },
  created: function created() {
    var _this3 = this;

    Bus.$on('checkBuyTicket', function () {
      _this3.buyTicket();
    });
  }
};